import classNames from 'classnames/bind';
import styles from '@/styles/superstack/base/LinkTag.module.scss';
const cx = classNames.bind(styles);

export default function LinkTag({ href, hoverable, ...props }) {
  return (
    <a className={cx(['link-tag', hoverable ? 'hover-underline' : ''])} href={href} {...props}>
      {props.children}
    </a>
  );
}
